import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { useEffect, useState } from "react";
import axios from "axios";
import { api_url, AXIOS_HEADER } from "../../constants/data";
import moment from "moment";



const Home = () => {
    const navigate = useNavigate(); // Initialize the navigate function
    const[type, setType] = useState(0)
    const[tasks, setTasks] = useState([])
    const [searchParams, setSearchParams] = useSearchParams();
    const keyword = searchParams.get("q")

    useEffect(() => {
        axios.post(`${api_url}/tasks`, {type, keyword}, AXIOS_HEADER).then(res => {
            setTasks(res.data)
        })
    }, [type, keyword])

    return (
        <DashboardLayout>
            <div className="header_wrapper">
                <div className="header_icon">
                    <img src="/icons/flag.png" alt="" />
                </div>
                <div className="header_title">
                    <p>დავალებები</p>
                </div>
            </div>

            <div className="tasks_statuses">
                <div className={`tasks_status_item ${type == 0 ? 'active' : ''}`} onClick={() => setType(0)}>
                    <p>შეუსრულებელი</p>
                </div>
                <div className={`tasks_status_item ${type == 1 ? 'active' : ''}`} onClick={() => setType(1)}>
                    <p>ვადაგადაცილებული</p>
                </div>
                <div className={`tasks_status_item ${type == 2 ? 'active' : ''}`} onClick={() => setType(2)}>
                    <p>შესრულებული</p>
                </div>
            </div>

            <div className="task_list">
                <div className="task_list_header">
                    <div className="tr empty"></div>
                    <div className="tr empty"></div>
                    <div className="tr empty"></div>
                    <div className="tr department">
                        <p>განყოფილება</p>
                    </div>
                    <div className="tr anfang">
                        <p>დასაწყისი <img src="/icons/arrow-sort.svg" alt="" /></p>
                    </div>
                    <div className="tr department">
                        <p>დასასრული <img src="/icons/arrow-sort.svg" alt="" /></p>
                    </div>
                    <div className="tr full">
                        <p>დავალების სათაური</p>
                    </div>
                </div>

                { tasks && tasks.map((task, index) => (
                    <div className="task_list_body" onClick={() => navigate(`/task/${task.id}`)} key={index}>
                        <div className="tr empty">
                            { task.prio == 1 && (
                                <img src="/images/red-flag.png" alt="" style={{ height: '20px', margin: '0 16px'}} />
                            ) }
                        </div>
                        <div className="tr empty">
                            <img src="/icons/mail.png" alt="" />
                            {!task.user_read && (
                                <span className="unread">*</span>
                            )}
                        </div>
                        <div className="tr empty">
                            <img src="/icons/chat1.png" alt="" />
                            {!task.comment_read && task.comments.length > 0 && (
                                <span className="unread">*</span>
                            )}
                        </div>
                        <div className="tr department">
                            <p>{ task.departments.map(x => x.department.short_name).join(', ') }</p>
                        </div>
                        <div className="tr anfang">
                            <p>{ moment(task.date_start).format('YYYY-MM-DD') }</p>
                        </div>
                        <div className="tr department">
                            <p>{ moment(task.date_end).format('YYYY-MM-DD') }</p>
                        </div>
                        <div className="tr full">
                            <p>{ task.title }</p>
                        </div>
                    </div>
                ))}
                
            </div>

            <div className="task_pagination">
                <div className="tp_total">
                    <p>Total</p>
                    <div className="total_n">
                        <p>15</p>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}
  
export default Home